<div class="books-wrapper">
    <div class="legs-info-table-container table-container table-background-color">

        <table mat-table [dataSource]="dataSource" class="positions-table books-table" matSort>

            <ng-container matColumnDef="order_mode">
                <th mat-header-cell *matHeaderCellDef mat-sort-header>Order Mode</th>
                <td mat-cell *matCellDef="let element" [ngClass]="{'text-positive': element.orderMode === ORDER_MODE.BUY,
            'text-negative': element.orderMode === ORDER_MODE.SELL}" class="font-bold">
                    <span>{{element.orderMode | orderMode}}</span>
                </td>
            </ng-container>

            <ng-container matColumnDef="instrument">
                <th mat-header-cell *matHeaderCellDef mat-sort-header>Instrument Type</th>
                <td mat-cell *matCellDef="let element">
                    <span>{{element.instrumentType}}</span>
                </td>
            </ng-container>


            <ng-container matColumnDef="expiry">
                <th mat-header-cell *matHeaderCellDef mat-sort-header>Expiry</th>
                <td mat-cell *matCellDef="let element">
                    <span>{{element.expiry}}</span>
                </td>
            </ng-container>

            <ng-container matColumnDef="strike">
                <th mat-header-cell *matHeaderCellDef mat-sort-header>Strike Price</th>
                <td mat-cell *matCellDef="let element">
                    <span>{{element.strikePrice | nullCheck}}</span>
                </td>
            </ng-container>

            <ng-container matColumnDef="lots">
                <th mat-header-cell *matHeaderCellDef mat-sort-header>Lots</th>
                <td mat-cell *matCellDef="let element">
                    <span>{{element.lots}}</span>
                </td>
            </ng-container>
            
            <ng-container matColumnDef="symbol">
                <th mat-header-cell *matHeaderCellDef mat-sort-header>Symbol</th>
                <td mat-cell *matCellDef="let element">
                    <span>{{element.symbol }}
                    </span>
                </td>
            </ng-container>

            <ng-container matColumnDef="series">
                <th mat-header-cell *matHeaderCellDef mat-sort-header>Series</th>
                <td mat-cell *matCellDef="let element">
                    <span>{{element.series}}
                    </span>
                </td>
            </ng-container>

            <ng-container matColumnDef="target_profit">
                <th mat-header-cell *matHeaderCellDef mat-sort-header>Target Profit</th>
                <td mat-cell *matCellDef="let element">
                    <span>{{element.targetProfit | localeConverter: 2: true: true | percentPipe:element.targetProfitType |
                        nullCheck : false}}
                    </span>
                </td>
            </ng-container>

            <ng-container matColumnDef="stop_loss">
                <th mat-header-cell *matHeaderCellDef mat-sort-header>Stop Loss</th>
                <td mat-cell *matCellDef="let element">
                    <span>{{element.stopLoss | localeConverter: 2: true: true | percentPipe:element.stopLossType |
                        nullCheck : false}}
                    </span>
                </td>
            </ng-container>

            <tr mat-header-row *matHeaderRowDef="displayedColumns">
            </tr>
            <tr mat-row *matRowDef="let row; columns: displayedColumns;">
            </tr>
        </table>
    </div>
</div>
